import api from '../utils/baseUrl';

class AdvertiserService {
    async getBestAdvertisers(filters: {
        userType?: string;
        search?: string;
        sortBy?: string;
        sortDirection?: 'asc' | 'desc';
    } = {}) {
        try {
            const response = await api.get('/api/advertisers/best', {params: filters});
            return response.data ?? {};
        } catch (error) {
            console.error('Error fetching best advertisers:', error);
            return [];
        }
    }

    async becomeAdvertiser() {
        return await api.post('/api/advertisers/become');
    }

    async getAdvertiser(advertiserId: string) {
        try {
            const response = await api.get(`/api/advertisers/${advertiserId}`);
            return response.data ?? {};
        } catch (error) {
            console.error('Error fetching advertiser data:', error);
            return [];
        }
    }

    async getCampaignsByAdvertiserId(advertiserId: string, filters: {
        status?: string;
        search?: string;
        sortBy?: string;
        sortDirection?: 'asc' | 'desc';
    } = {}) {
        try {
            const response = await api.get(`/api/advertisers/${advertiserId}/campaigns`, {params: filters});
            return Array.isArray(response.data.campaigns) ? response.data.campaigns : [];
        } catch (error) {
            console.error('Error fetching advertiser campaigns:', error);
            return [];
        }
    }
}

export default new AdvertiserService();